import styled from "styled-components";

export const MainProfileSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const MainProfileBox = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10px;
  align-items: center;
  gap: 26px;
`;

export const MainProfile = styled.div`
  width: 70px;
  height: 70px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadow.box};
  border-radius: 100%;
  padding: 6px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

export const ProfileTxtBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const UserStatusBox = styled.div`
  display: flex;
  font-size: 2rem;
  letter-spacing: -0.08rem;
  flex-direction: column;
  gap: 6px;

  span {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 700;
  }
`;

export const UserAuthSpan = styled.span`
  font-size: 1.5rem;
  font-weight: 600;
`;

export const ProfileDate = styled.div`
  color: ${(props) => props.theme.colors.placeholderTxt};
  font-size: 1.2rem;
`;
